import { render, staticRenderFns } from "./NoCustomerYet.vue?vue&type=template&id=88a754a8&scoped=true&"
import script from "./NoCustomerYet.vue?vue&type=script&lang=js&"
export * from "./NoCustomerYet.vue?vue&type=script&lang=js&"
import style0 from "./NoCustomerYet.vue?vue&type=style&index=0&id=88a754a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a754a8",
  null
  
)

export default component.exports